(function () {
  "use strict";

  var popup = document.getElementById("jacket-rewards-popup");
  if (!popup) return;

  var sheet = popup.querySelector(".jr-sheet");
  var closeButton = popup.querySelector("[data-jr-close]");
  var form = popup.querySelector(".jr-form");
  var email = popup.querySelector('input[type="email"]');
  var submit = popup.querySelector('button[type="submit"]');
  var error = popup.querySelector(".jr-form-error");
  var success = popup.querySelector("[data-jr-success]");
  var serverError = popup.querySelector("[data-jr-server-error]");
  var successClose = popup.querySelector("[data-jr-success-close]");
  var delay = Math.min(Number(popup.getAttribute("data-delay")) || 4500, 4500);
  var dismissDays = Number(popup.getAttribute("data-dismiss-days")) || 7;
  var joinedKey = "jacketRewardsJoined";
  var dismissedKey = "jacketRewardsDismissedAt";
  var sessionKey = "jacketRewardsSeenThisSession";
  var scrollKey = "jacketRewardsReturnPosition";
  var lastFocus = null;
  var closeTimer = null;

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (e) { return null; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (e) {}
  }

  function isDismissed() {
    var dismissedAt = Number(storageGet(window.localStorage, dismissedKey));
    if (!dismissedAt) return false;
    return Date.now() - dismissedAt < dismissDays * 24 * 60 * 60 * 1000;
  }

  function anotherOverlayIsOpen() {
    return Boolean(document.querySelector("#derm-modal.open, #cart-drawer.open, #mobile-menu.open"));
  }

  function openPopup(force) {
    if (!force && (storageGet(window.localStorage, joinedKey) || isDismissed() || storageGet(window.sessionStorage, sessionKey))) return;
    if (anotherOverlayIsOpen()) {
      window.setTimeout(function () { openPopup(force); }, 1000);
      return;
    }

    lastFocus = document.activeElement;
    popup.hidden = false;
    storageSet(window.sessionStorage, sessionKey, "1");
    document.body.classList.add("jr-modal-open");
    window.requestAnimationFrame(function () {
      popup.classList.add("is-open");
      window.setTimeout(function () {
        if (successClose) successClose.focus();
        else if (email) email.focus();
      }, 420);
    });
  }

  function saveReturnPosition() {
    storageSet(window.sessionStorage, scrollKey, JSON.stringify({
      path: window.location.pathname,
      y: window.scrollY || window.pageYOffset || 0
    }));
  }

  function restoreReturnPosition() {
    var stored = storageGet(window.sessionStorage, scrollKey);
    if (!stored) return;
    try {
      var position = JSON.parse(stored);
      if (position.path === window.location.pathname && Number.isFinite(Number(position.y))) {
        window.scrollTo(0, Number(position.y));
        window.setTimeout(function () { window.scrollTo(0, Number(position.y)); }, 120);
      }
    } catch (e) {}
    try { window.sessionStorage.removeItem(scrollKey); } catch (e) {}
  }

  function closePopup() {
    window.clearTimeout(closeTimer);
    storageSet(window.localStorage, dismissedKey, String(Date.now()));
    popup.classList.remove("is-open");
    document.body.classList.remove("jr-modal-open");
    closeTimer = window.setTimeout(function () {
      popup.hidden = true;
      if (lastFocus && typeof lastFocus.focus === "function") {
        try { lastFocus.focus(); } catch (e) {}
      }
      lastFocus = null;
    }, 430);
  }

  if (closeButton) closeButton.addEventListener("click", closePopup);
  if (successClose) successClose.addEventListener("click", closePopup);
  popup.addEventListener("click", function (event) {
    if (event.target === popup) closePopup();
  });

  if (form) {
    form.addEventListener("submit", function (event) {
      if (!email || !email.checkValidity()) {
        event.preventDefault();
        if (email) {
          email.setAttribute("aria-invalid", "true");
          email.focus();
        }
        if (error) error.hidden = false;
        return;
      }

      saveReturnPosition();
      if (error) error.hidden = true;
      email.removeAttribute("aria-invalid");
      if (submit) {
        submit.disabled = true;
        submit.textContent = "Joining…";
      }
    });

    if (email) {
      email.addEventListener("invalid", function () {
        email.setAttribute("aria-invalid", "true");
        if (error) error.hidden = false;
      });
      email.addEventListener("input", function () {
        email.removeAttribute("aria-invalid");
        if (error) error.hidden = true;
      });
    }
  }

  document.addEventListener("keydown", function (event) {
    if (popup.hidden) return;
    if (event.key === "Escape") {
      closePopup();
      return;
    }
    if (event.key !== "Tab" || !sheet) return;

    var focusable = Array.prototype.filter.call(
      sheet.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function (element) { return element.offsetParent !== null; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (success || serverError) {
    restoreReturnPosition();
    if (success) {
      storageSet(window.localStorage, joinedKey, String(Date.now()));
      try { window.localStorage.removeItem(dismissedKey); } catch (e) {}
    }
    window.setTimeout(function () { openPopup(true); }, 50);
  } else {
    window.setTimeout(function () { openPopup(false); }, delay);
  }
})();
